// src/pages/ApplyPage.jsx
import React, { useState } from 'react';
import Header from '../components/Header';
import { API_BASE_URL } from '../config';
import './ApplyPage.css';

export default function ApplyPage() {
  const [formData, setFormData] = useState({
    name: '',
    age: '',
    address: '',
    phone: '',
    email: '',
    hobby: '',
    motive: ''
  });

  const [isSubmitting, setIsSubmitting] = useState(false);

  const formatPhoneNumber = (input) => {
    const onlyNums = input.replace(/\D/g, '');
    if (onlyNums.startsWith('02')) {
      if (onlyNums.length <= 2) return onlyNums;
      if (onlyNums.length <= 5) return `${onlyNums.slice(0, 2)}-${onlyNums.slice(2)}`;
      if (onlyNums.length <= 9) return `${onlyNums.slice(0, 2)}-${onlyNums.slice(2, 5)}-${onlyNums.slice(5)}`;
      return `${onlyNums.slice(0, 2)}-${onlyNums.slice(2, 6)}-${onlyNums.slice(6, 10)}`;
    }
    if (onlyNums.length <= 3) return onlyNums;
    if (onlyNums.length <= 6) return `${onlyNums.slice(0, 3)}-${onlyNums.slice(3)}`;
    if (onlyNums.length <= 10) return `${onlyNums.slice(0, 3)}-${onlyNums.slice(3, 6)}-${onlyNums.slice(6)}`;
    return `${onlyNums.slice(0, 3)}-${onlyNums.slice(3, 7)}-${onlyNums.slice(7, 11)}`;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    const newValue = name === 'phone' ? formatPhoneNumber(value) : value;
    setFormData((prev) => ({ ...prev, [name]: newValue }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isSubmitting) return; // 중복 클릭 방지
    setIsSubmitting(true);

    try {
      const res = await fetch(`${API_BASE_URL}/api/apply`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData)
      });

      if (!res.ok) {
        const msg = await res.text().catch(() => '');
        alert(`신청에 실패했습니다.\n${msg || `HTTP ${res.status}`}`);
        return;
      }

      alert('신청이 완료되었습니다!');
      setFormData({
        name: '',
        age: '',
        address: '',
        phone: '',
        email: '',
        hobby: '',
        motive: ''
      });
    } catch (err) {
      console.error(err);
      alert('서버 에러가 발생했습니다.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <Header />
      <div className="apply-container">
        <h2 className="apply-title">에버영라이프 신청서</h2>

        <form className="apply-form" onSubmit={handleSubmit}>
          <input
            type="text"
            name="name"
            placeholder="이름"
            value={formData.name}
            onChange={handleChange}
            required
            disabled={isSubmitting}
          />

          <input
            type="number"
            name="age"
            min="0"
            placeholder="나이"
            value={formData.age}
            onChange={handleChange}
            required
            disabled={isSubmitting}
          />

          <input
            type="text"
            name="address"
            placeholder="주소"
            value={formData.address}
            onChange={handleChange}
            required
            disabled={isSubmitting}
          />

          <input
            type="tel"
            name="phone"
            placeholder="전화번호"
            value={formData.phone}
            onChange={handleChange}
            required
            disabled={isSubmitting}
          />

          {/* 이메일 '없음' 허용 */}
          <input
            type="text"
            name="email"
            placeholder="이메일"
            value={formData.email}
            onChange={handleChange}
            pattern="^없음$|^[^\s@]+@[^\s@]+\.[^\s@]+$"
            title="@이 포함된 이메일 형식 또는 '없음'만 입력 가능합니다."
            required
            disabled={isSubmitting}
          />
          <small className="email-hint">*이메일이 없다면 '없음'이라고 써주십시오</small>

          <input
            type="text"
            name="hobby"
            placeholder="개인 취미"
            value={formData.hobby}
            onChange={handleChange}
            required
            disabled={isSubmitting}
          />

          <textarea
            name="motive"
            placeholder="지원 동기"
            rows="4"
            value={formData.motive}
            onChange={handleChange}
            required
            disabled={isSubmitting}
          />

          <button type="submit" disabled={isSubmitting}>
            {isSubmitting ? '신청 중…' : '신청하기'}
          </button>
        </form>
      </div>
    </>
  );
}